import {$window, $body} from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';
import HtmlElement from '../../../../../../ig_template/Resources/Public/Src/Js/Elements/HtmlElement';

/**
 * Scroll Table
 */
const ScrollTable = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		SCROLL_TABLE: '.scroll-table',
		TABLE_WRAP: '.scroll-table-wrap',
		TABLE: '.scroll-table-table'
	};

	/**
	 * Scroll Table
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class ScrollTable extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.$tableWrap = this.$element.find(Selector.TABLE_WRAP);
			this.$table = this.$element.find(Selector.TABLE);
			this.$fixedTable = null;
			this.isScrollable = false;

			this._handleTable();
			this._bindHandlers();
		}

		_bindHandlers() {
			$window.on('resize', () => {
				this._handleTable();
			})
		}

		_handleTable() {
			if (!this.isScrollable && this.$table.outerWidth() > this.$tableWrap.outerWidth()) {
				this._initializeScrollTable();
				this.isScrollable = true;
				this.$element.addClass('is-scrollable');
			} else {
				this._deconstructScrollTable();
				this.isScrollable = false;
				this.$element.removeClass('is-scrollable');
			}
		}

		_initializeScrollTable() {
			const $fixedTable = $('<table class="scroll-table-fixed"><tbody></tbody></table>');
			const $tbody = $fixedTable.find('tbody');

			this.$table.find('tr').each((i, el) => {
				const $tr = $(el);
				const $firstTd = $tr.find('td:first-of-type');
				let $firstTdClone = $firstTd.clone();

				let trString = '<tr></tr>';

				if (i === 0) {
					trString = '<tr class="thead"></tr>';
				}

				$firstTdClone.css('height', $firstTd.outerHeight());
				$firstTdClone = $firstTdClone.wrap(trString).parent('tr');

				$tbody.append($firstTdClone);
			});

			$fixedTable.appendTo(this.$tableWrap);
			this.$fixedTable = $fixedTable;

			this.$tableWrap.on('scroll', () => {
				if (this._isScrolledToRightEnd()) {
					this.$element.addClass('scrolled-right-end');
				} else {
					this.$element.removeClass('scrolled-right-end');
				}
			});
		}

		_deconstructScrollTable() {
			if (this.$fixedTable && this.$fixedTable.length) {
				this.$fixedTable.remove();
				this.$tableWrap.off('scroll');
			}
		}

		_isScrolledToRightEnd() {
			const tableWrap = this.$tableWrap.get(0);
			return tableWrap.scrollWidth - tableWrap.scrollLeft === tableWrap.clientWidth;
		}
	}

	return ScrollTable._getElements(Selector.SCROLL_TABLE, ScrollTable);
})();

export default ScrollTable;
